import './messageBanner.scss';
import styling from '../core/styling.js';
import { getRequired, create, createDiv } from '../core/domMan';
export const wrapperName = 'messageBannerWrapper';
export const identifier = 'messageBanner';
export default (owner) => {
    let result = {};
    let messageBanner = document.getElementById(identifier);
    if (messageBanner) {
        Object.assign(result, {
            messageBanner,
            title: getRequired('messageBanner-title'),
        });
    }
    else {
        owner = owner ?? getRequired(wrapperName);
        result.messageBanner = messageBanner = createDiv(owner, { id: identifier, tabindex: "-1", className: 'fixed top-0 left-0 z-50 flex justify-between w-full p-2 border-b border-gray-200 dark:border-gray-600' });
        const flexCenter = createDiv(messageBanner, {className: 'flex items-center mx-auto'}); 
        const paragraph = create( flexCenter, 'p', {className:'flex items-center text-sm font-normal text-slate-50'});
        result.title = create(paragraph, 'span', { id: 'messageBanner-title' });
        styling.hide(messageBanner);
    }

    result.setMessage = (message) => {
        if (message) {
            result.title.innerHTML = message;
        }
    }

    return result;
};